

import Vue from 'vue'
import App from './App'
import router from './router'


import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'


import VueQuickLoadmore from 'vue-quick-loadmore'




require('flexiblejs')



import('./assets/css/reset.css')

import('./assets/css/common.css')


require('es6-promise').polyfill()


const FastClick = require('fastclick')
FastClick.attach(document.body)

Vue.config.productionTip = false















Vue.use(AlertPlugin)
Vue.use(ToastPlugin)



Vue.use(VueQuickLoadmore)



/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js